import { BaseService } from "./BaseService";

export const IpuService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipu/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos ipus:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('ipu/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas ipus:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipu', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de ipus:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`ipu/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de ipus:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`ipu/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de ipus:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipu/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir ipus:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipu/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar ipus:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ipu/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar ipus:', error);
            return false;
        }
    }, 
}